import { z } from 'zod';

export const signInSchema = z.object({
  email: z.email({ error: 'Please enter a valid email address' }).trim(),
  password: z
    .string()
    .trim()
    .min(3, { error: 'Please enter a valid password' }),
});

export type SignInInput = z.infer<typeof signInSchema>;
